'use client';
import { faTwitter } from '@fortawesome/free-brands-svg-icons';
import ShibLink from '../atoms/shibLink';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Link from 'next/link';
import React, { useEffect, useState } from 'react';
import ShibLogo from '../atoms/shibLogo';
import { getLocalizedFooterLinks } from '../../constants';
import { useLocale } from 'next-intl';

const Footer = () => {
  const currentLocale = useLocale();
  const footerLinks = getLocalizedFooterLinks(currentLocale);

  const [isHidden, setIsHidden] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const isMapPage = window.location.href.includes('map');
      const isMobileDevice = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      const isMobileScreen = window.innerWidth <= 768;
      setIsHidden(isMapPage && (isMobileDevice || isMobileScreen));
    };

    // Initial check
    handleResize();

    // Add event listener for window resize
    window.addEventListener('resize', handleResize);

    // Cleanup event listener on component unmount
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <footer
      className={`absolute bottom-0 mx-auto flex w-full justify-center bg-black/10 px-4 backdrop-blur ${isHidden ? 'hidden' : ''}`}
    >
      <div className="flex w-full max-w-[1720px] flex-col items-center lg:flex-row">
        <ShibLogo className="h-[3rem]" />
        <div className="flex items-center justify-end md:w-full md:justify-center lg:ml-auto lg:w-auto">
          <div className="my-4 flex flex-col items-center text-white md:flex-col lg:flex-row lg:gap-8">
            {footerLinks.map(route => (
              <React.Fragment key={route?.href}>
                <ShibLink
                  href={route?.href}
                  className="active font-sora text-sm hover:text-orange-500 active:text-orange-500"
                  target={route?.target}
                >
                  {route.label}
                </ShibLink>
                <div className="hidden h-[16px] min-h-[16px] w-[1px] self-center bg-white lg:block"></div>
              </React.Fragment>
            ))}
          </div>
        </div>
        <Link
          href="https://twitter.com/mvshib"
          target="_blank"
          rel="noopener noreferrer"
          className="flex flex-col justify-center text-white lg:ml-12"
          style={{ borderRadius: '40px', background: '#f88523', width: '45px', height: '45px' }}
        >
          <FontAwesomeIcon icon={faTwitter} style={{ fontSize: '20px' }} />
        </Link>
      </div>
    </footer>
  );
};

export default Footer;
